import React from 'react';
import { Flex, Input, Typography } from 'antd';

import { welcomeMessageFormFields as fields } from '../utils/fields';
import { InputType, MainFormFields } from '../service/bot.interface';
import { ImageUpload } from '../../../../../shared/ui/ImageUploader';

const { Text } = Typography;

const inputRenderMap: Record<
    InputType,
    (
        placeholder: string,
        name: string,
        onChange: (name: string, value: string) => void,
        formik
    ) => JSX.Element
> = {
    [InputType.image]: (placeholder, name, onChange, formik) => (
        <Flex gap={8} vertical>
            <ImageUpload fieldName={name} isEdit={true} formik={formik} />
            <Text
                style={{
                    color: 'rgba(37, 33, 41, 0.45)',
                }}
            >
                Тип файлов: PNG, JPG, JPEG, GIF, вес до 10 МБ
            </Text>
        </Flex>
    ),
    [InputType.textArea]: (placeholder, name, onChange, formik) => (
        <Input.TextArea
            maxLength={100}
            style={{ height: 54, maxHeight: 254 }}
            onChange={e => onChange(name, e.target.value)}
            placeholder={placeholder}
            value={formik.values[name]}
        />
    ),
    [InputType.input]: (placeholder, name, onChange, formik) => (
        <Input
            placeholder={placeholder}
            value={formik.values[name]}
            onChange={e => onChange(name, e.target.value)}
        />
    ),
};

export const WelcomeMessageForm = ({ formik }) => {
    const renderInput = (
        item: MainFormFields,
        onChange: (name: string, value: string) => void,
        formik
    ) => {
        return (
            inputRenderMap[item.type]?.(
                item.placeholder,
                item.name,
                onChange,
                formik
            ) ?? null
        );
    };

    const onChange = (fieldName: string, value: string) => {
        formik.setFieldValue(fieldName, value);
    };

    return (
        <Flex
            vertical
            gap={24}
            style={{
                width: '578px',
            }}
        >
            {fields.map(item => (
                <Flex gap={8} vertical key={item.name}>
                    {item.title && <Text>{item.title}</Text>}
                    {renderInput(item, onChange, formik)}
                </Flex>
            ))}
        </Flex>
    );
};
